// runtime/source/site/journal/journal-layout.js
function initJournalLayout(root) {
  const rows = [...root.querySelectorAll(".bb-journal-row")];
  const header = document.querySelector(".bb-scroll-header");
  const desktop = matchMedia("(min-width: 901px)");
  let frame = 0;
  function measure() {
    frame = 0;
    const clearance = Math.ceil(header?.getBoundingClientRect().height ?? 81) + 32;
    for (const row of rows) {
      const card = row.querySelector(".bb-journal-card--medium");
      const sidebar = row.querySelector(".bb-journal-column--small");
      const height = card.getBoundingClientRect().height;
      card.style.setProperty("--bb-journal-sticky-top", `${Math.min(clearance, innerHeight - 32 - height)}px`);
      card.classList.toggle("bb-journal-card--sticky", desktop.matches && !!sidebar && sidebar.getBoundingClientRect().height > height);
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(measure);
  }
  const observer = new ResizeObserver(schedule);
  for (const row of rows) for (const column of row.children) observer.observe(column);
  if (header) observer.observe(header);
  window.addEventListener("resize", schedule);
  measure();
  return () => {
    cancelAnimationFrame(frame);
    observer.disconnect();
    window.removeEventListener("resize", schedule);
    for (const row of rows) {
      const card = row.querySelector(".bb-journal-card--medium");
      card.classList.remove("bb-journal-card--sticky");
      card.style.removeProperty("--bb-journal-sticky-top");
    }
  };
}
var mounted = /* @__PURE__ */ new Map();
function mount(scope) {
  for (const root of scope.querySelectorAll(".bb-native-blog")) if (!mounted.has(root)) mounted.set(root, initJournalLayout(root));
}
mount(document);
document.addEventListener("shopify:section:load", (event) => mount(event.target));
document.addEventListener("shopify:section:unload", (event) => {
  for (const [root, cleanup] of mounted) if (event.target.contains(root)) {
    cleanup();
    mounted.delete(root);
  }
});
